/**
 * Sources Sidebar Component
 * 
 * Displays a list of source titles in the right sidebar.
 * Clicking scrolls to the full sources section at the bottom.
 */

"use client";

export interface Source {
  url: string;
  title: string;
  description: string;
}

interface SourcesSidebarProps {
  sources: Source[];
}

export default function SourcesSidebar({ sources }: SourcesSidebarProps) {
  if (sources.length === 0) {
    return null;
  }

  const scrollToSource = (index: number) => {
    const element = document.getElementById(`source-${index + 1}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="border border-gray-200 bg-white rounded p-4 shadow-sm">
      <h3 className="font-poppins text-lg font-semibold text-gray-900 pb-3 border-b border-gray-200">
        Sources
      </h3>
      
      <div className="mt-3 space-y-2">
        {sources.map((source, index) => (
          <button
            key={index}
            onClick={() => scrollToSource(index)}
            className="w-full text-left px-3 py-2 rounded hover:bg-gray-50 transition-colors group"
          >
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center w-6 h-6 bg-gray-100 rounded font-poppins text-xs font-semibold text-gray-900 flex-shrink-0">
                {index + 1}
              </span>
              <span className="font-poppins text-sm text-gray-600 group-hover:text-gray-900 line-clamp-2">
                {source.title}
              </span>
            </div>
          </button>
        ))}
      </div>
      
      <p className="mt-4 pt-3 border-t border-gray-200 text-xs text-gray-500 font-poppins">
        Click to view full source details
      </p>
    </div>
  );
}

